import { createClient } from '@meteor/rpc/client';
import { AuthClient } from './src/apis/id/auth';

export let createAuthClient = ({ host }: { host: string }) =>
  createClient<AuthClient>({ endpoint: `${host}/id` });

export type { AuthClient };
